import { render } from "./LenhView.vue?vue&type=template&id=2b1281eb&scoped=true"
import script from "./LenhView.vue?vue&type=script&lang=js"
export * from "./LenhView.vue?vue&type=script&lang=js"

import "./LenhView.vue?vue&type=style&index=0&id=2b1281eb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1281eb"]])

export default __exports__